var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 14.78h4M19 3.5H5a2 2 0 00-2 2v13c0 1.1.9 2 2 2h14a2 2 0 002-2v-13a2 2 0 00-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5l.92.83 1.85-1.66M13 9.78h4M7 9.5l.92.83 1.85-1.66"
  }))));
}
export default SvgTask;